import React, { Component } from 'react';

import autoBind from 'react-autobind';
import ProfileSection from 'ui/users/profile-section';
import query from './user-query.gql';
import Loading from 'ui/common/loading';
import Button from 'ui/common/button';

import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { TabHeader, TabItem, TabLink } from 'ui/common/tabs';
import { withApollo } from 'react-apollo';
import routeTemplates from 'ui/common/routes/templates';

import { getUserEvaluations } from 'store/graphql/UserEvaluations/actions';
import {
  selectIsFetching,
  selectError,
  selectGetAllAssignmentsEvaluation,
  selectGetAllChatbotEvaluation,
  selectGetAllClaimsEvaluation,
} from 'store/graphql/UserEvaluations/selectors';
import { resultHasErrors } from 'utils/graphql-errors';

import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import UserEvaluationsReducer from 'store/graphql/UserEvaluations/reducer';
// import RecommendedCourses from 'ui/graphql/RecommendedCourses';
import AssignmentListItem from 'ui/graphql/AssignmentListItem';
import ClaimListItem from './claim-list-item';
import { scrollTo } from 'ui/common/scroller';
import MediaQuery from 'react-responsive';
import themeConfig from 'ui/theme/config';
import matchMedia from 'matchmediaquery';

const {
  start: getUserEvaluationStart,
  success: getUserEvaluationSuccess,
  failure: getUserEvaluationFailure,
} = getUserEvaluations;

const messages = defineMessages({
  title: {
    id: 'users.evaluation.title',
    defaultMessage: 'My Evaluations',
    currentTab: false, // false means all skills
  },
  allEvaluation: {
    id: 'users.evaluation.category.type.all-evaluation',
    defaultMessage: 'All Evaluations',
  },
});

class Evaluations extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      activeTab: 'allEvaluation',
    };
  }

  componentDidMount() {
    const { showAllEval } = this.props;

    if (showAllEval) {
      this.setState({
        activeTab: 'chatbot',
      });
    }
    this.executeQuery();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showAllEval !== this.props.showAllEval) {
      this.setState({
        activeTab: 'allEvaluation',
      });
    }
  }

  async executeQuery() {
    const {
      getUserEvaluationStart,
      getUserEvaluationSuccess,
      getUserEvaluationFailure,
      client,
    } = this.props;

    getUserEvaluationStart();

    try {
      const response = await client.query({
        query,
      });

      if (resultHasErrors(response)) {
        getUserEvaluationFailure({ errors: response.errors });
      } else {
        const { getUserEvaluations } = response.data;
        getUserEvaluationSuccess({
          result: {
            chatbots: getUserEvaluations.chatbots,
            assignments: getUserEvaluations.assignments,
            claims: getUserEvaluations.claims,
          },
        });
      }
    } catch (error) {
      getUserEvaluationFailure({
        errors: error.messages,
      });
    }
  }

  onToggle(tab) {
    this.setState({
      activeTab: tab,
    });
  }

  toggleSeeMore(tab) {
    setTimeout(() => {
      scrollTo('evaluations');
    }, 500);
    this.setState({
      activeTab: tab,
    });
  }

  renderTabHeader() {
    const { intl: { formatMessage } } = this.props;

    const { activeTab } = this.state;

    const userEvaluations = [
      {
        key: 'assignment',
        displayName: 'Assignments',
      },
      {
        key: 'claim',
        displayName: 'Personal Projects',
      },
    ];

    return (
      <div>
        <TabHeader>
          <TabItem>
            <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.md}>
              <TabLink
                onClick={() => this.onToggle('allEvaluation')}
                active={activeTab === 'allEvaluation'}
              >
                {formatMessage(messages.allEvaluation)}
              </TabLink>
            </MediaQuery>
          </TabItem>
          {userEvaluations.map((userEvaluation, index) => {
            return (
              <TabItem key={index}>
                <TabLink
                  onClick={() => this.onToggle(userEvaluation.key)}
                  active={activeTab.toString().toLowerCase() === userEvaluation.key}
                >
                  {userEvaluation.displayName}
                </TabLink>
              </TabItem>
            );
          })}
        </TabHeader>
      </div>
    );
  }

  renderAssignments() {
    const { assignmentEvaluations } = this.props;
    const { assignments } = assignmentEvaluations;

    const { activeTab } = this.state;
    return (
      <div className="pt-3 pb-2">
        {assignments &&
          assignments.map(
            (assignment, index) =>
              activeTab === 'allEvaluation' ? (
                index < 3 && <AssignmentListItem key={assignment._id} assignment={assignment} />
              ) : (
                <AssignmentListItem key={assignment._id} assignment={assignment} />
              )
          )}
        {/* <div className="row">
          <div className="col-12 col-md-12">
            <RecommendedCourses />
          </div>
        </div> */}
      </div>
    );
  }

  renderClaims() {
    const { claimEvaluation, hasClaims } = this.props;
    const { claims } = claimEvaluation;

    const { activeTab } = this.state;

    return (
      <div className="pt-3">
        {hasClaims ? (
          claims &&
          claims.map(
            (claim, index) =>
              activeTab === 'allEvaluation' ? (
                index < 3 && <ClaimListItem claim={claim} key={index} />
              ) : (
                <ClaimListItem claim={claim} key={index} />
              )
          )
        ) : (
          <div className="text-center pt-2">
            <p className="pb-3">
              Get your development skills evaluated by our experts by submitting a public project
            </p>
            <Button isReady={true} to={routeTemplates.claims.new}>
              Submit Project
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      hasAssignments,
      intl: { formatMessage },
      isFetching,
      claimEvaluation,

      assignmentEvaluations,
    } = this.props;

    const { activeTab } = this.state;

    if (isFetching) return <Loading />;

    return (
      <div className="row" id="evaluations">
        <ProfileSection title={formatMessage(messages.title)} collapsible className="col-12 py-4">
          <div className="row pb-3">
            <div className="col-12">{this.renderTabHeader()}</div>
          </div>
          <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.md}>
            {activeTab === 'allEvaluation' && (
              <div className="px-3">
                {hasAssignments && (
                  <section className="pt-2 pb-3">
                    <header className="d-flex justify-content-between">
                      <h3 className="mb-0">Assignments</h3>
                      {assignmentEvaluations &&
                        assignmentEvaluations.assignments.length > 3 && (
                          <Button
                            color="secondary"
                            className="pt-0"
                            onClick={() => this.toggleSeeMore('assignment')}
                          >
                            View more
                          </Button>
                        )}
                    </header>

                    <hr />
                    {this.renderAssignments()}
                  </section>
                )}
                <section className="pt-2 pb-3">
                  <header className="d-flex justify-content-between">
                    <h3 className="mb-0">Personal Projects</h3>

                    {claimEvaluation &&
                      claimEvaluation.claims &&
                      claimEvaluation.claims.length > 3 && (
                        <Button
                          color="secondary"
                          className="pt-0"
                          onClick={() => this.toggleSeeMore('claim')}
                        >
                          View more
                        </Button>
                      )}
                  </header>

                  <hr />
                  {this.renderClaims()}
                </section>
              </div>
            )}
          </MediaQuery>

          {activeTab === 'assignment' && this.renderAssignments()}

          {activeTab === 'claim' && this.renderClaims()}
        </ProfileSection>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const assignmentEvaluations = selectGetAllAssignmentsEvaluation(state);
  const hasAssignments =
    assignmentEvaluations &&
    assignmentEvaluations.assignments &&
    assignmentEvaluations.assignments.length > 0;
  const chatbotEvaluations = selectGetAllChatbotEvaluation(state);
  const hasChatbots =
    chatbotEvaluations && chatbotEvaluations.chatbots && chatbotEvaluations.chatbots.length > 0;
  const claimEvaluation = selectGetAllClaimsEvaluation(state);
  const hasClaims = claimEvaluation && claimEvaluation.claims && claimEvaluation.claims.length > 0;

  const showAllEval = matchMedia(`(max-width: ${themeConfig.layout.gridBreakpoints.sm}px)`).matches;

  return {
    assignmentEvaluations,
    hasAssignments,
    chatbotEvaluations,
    hasChatbots,
    claimEvaluation,
    hasClaims,
    isFetching: selectIsFetching(state),
    error: selectError(state),
    showAllEval,
  };
}

const mapDispatchToProps = {
  getUserEvaluationStart,
  getUserEvaluationSuccess,
  getUserEvaluationFailure,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withUserEvaluationsReducer = injectReducer({
  key: 'UserEvaluations',
  reducer: UserEvaluationsReducer,
});

export default compose(withUserEvaluationsReducer, withConnect)(
  injectIntl(withApollo(Evaluations))
);
